module.exports = __webpack_public_path__ + "media/components/src/assets/images/gallery_4-e71d8bbe155c81a1b76e4217796c8f2b.jpg";